var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "traffic-container"
  }, [_c('div', {
    staticClass: "t_container"
  }, [_c('div', {
    staticClass: "traffic_item_wrap",
    class: {
      'active_traffic_item_wrap': _vm.currentWay == 0
    },
    on: {
      "click": function($event) {
        _vm.currentWay = 0
      }
    }
  }, [_c('div', {
    staticClass: "media_font_size_50"
  }, [_vm._v(_vm._s(_vm.$t("transportation.metro")))])]), _vm._v(" "), _c('div', {
    staticClass: "traffic_item_wrap",
    class: {
      'active_traffic_item_wrap': _vm.currentWay == 1
    },
    on: {
      "click": function($event) {
        _vm.currentWay = 1
      }
    }
  }, [_c('div', {
    staticClass: "media_font_size_50"
  }, [_vm._v(_vm._s(_vm.$t("transportation.taxi")))])]), _vm._v(" "), _c('div', {
    staticClass: "traffic_item_wrap",
    class: {
      'active_traffic_item_wrap': _vm.currentWay == 2
    },
    on: {
      "click": function($event) {
        _vm.currentWay = 2
      }
    }
  }, [_c('div', {
    staticClass: "media_font_size_50"
  }, [_vm._v(_vm._s(_vm.$t("transportation.driving")))])])]), _vm._v(" "), _c('div', {
    staticClass: "traffic_content"
  }, [(_vm.currentWay == 0) ? _c('p', {
    staticClass: "media_font_size_50",
    domProps: {
      "innerHTML": _vm._s(_vm._i18n.locale == 'zh' ? _vm.metroContent.zh : _vm.metroContent.en)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.currentWay == 1) ? _c('p', {
    staticClass: "media_font_size_50",
    domProps: {
      "innerHTML": _vm._s(_vm._i18n.locale == 'zh' ? _vm.taxiConent.zh : _vm.taxiConent.en)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.currentWay == 2) ? _c('div', {
    staticClass: "drive"
  }, [_c('div', {
    staticClass: "dContent"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t("transportation.para1")))]), _c('p', [_vm._v(_vm._s(_vm.$t("transportation.para2")))]), _c('div', {
    staticStyle: {
      "text-align": "center",
      "padding-bottom": "20px"
    }
  }, [_vm._m(0), _c('br'), _vm._v(_vm._s(_vm.$t("transportation.para3"))), _c('br')]), _c('p', [_vm._v(_vm._s(_vm.$t("transportation.para4")))]), _c('div', {
    staticStyle: {
      "text-align": "center",
      "padding-bottom": "20px"
    }
  }, [_vm._m(1), _c('br'), _vm._v(_vm._s(_vm.$t("transportation.para5"))), _c('br')]), _c('p', [_vm._v(_vm._s(_vm.$t("transportation.para6")))]), _c('div', {
    staticStyle: {
      "text-align": "center",
      "padding-bottom": "20px"
    }
  }, [_vm._m(2), _c('br'), _vm._v(_vm._s(_vm.$t("transportation.para7"))), _c('br')]), _c('p', [_vm._v(_vm._s(_vm.$t("transportation.para8")))]), _c('div', {
    staticStyle: {
      "text-align": "center",
      "padding-bottom": "20px"
    }
  }, [_vm._m(3), _c('br'), _vm._v(_vm._s(_vm.$t("transportation.para9"))), _c('br')]), _c('p', [_vm._v(_vm._s(_vm.$t("transportation.para10")) + " ")])])]) : _vm._e()])])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/static/img/201905230416241624669.jpg"
    }
  }, [_c('img', {
    attrs: {
      "title": "从东面自驾车",
      "border": "0",
      "src": "https://cmsfile.cantonfair.org.cn/fileserver/booking/2019-05/201905230416241624669_b.jpg"
    }
  })])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "https://cmsfile.cantonfair.org.cn/fileserver/booking/2019-05/20190523041709179385.jpg"
    }
  }, [_c('img', {
    attrs: {
      "title": "从南面自驾车",
      "border": "0",
      "src": "https://cmsfile.cantonfair.org.cn/fileserver/booking/2019-05/20190523041709179385_b.jpg"
    }
  })])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "https://cmsfile.cantonfair.org.cn/fileserver/booking/2019-05/201905230417551755516.jpg"
    }
  }, [_c('img', {
    attrs: {
      "title": "从西面自驾车",
      "border": "0",
      "src": "https://cmsfile.cantonfair.org.cn/fileserver/booking/2019-05/201905230417551755516_b.jpg"
    }
  })])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "https://cmsfile.cantonfair.org.cn/fileserver/booking/2019-05/20190523041900190468.jpg"
    }
  }, [_c('img', {
    attrs: {
      "title": "从北面自驾车",
      "border": "0",
      "src": "https://cmsfile.cantonfair.org.cn/fileserver/booking/2019-05/20190523041900190468_b.jpg"
    }
  })])
}]
export default { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-32eebf32","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/schedule/components/traffic.vue
// module id = null
// module chunks = 